import { lazy } from 'react';

export const Dashboard = lazy(() => import('../pages/Dashboard'));
export const ActivityLog = lazy(() => import('../pages/ActivityLog/ActivityLog'));
export const AddStudentApplication = lazy(() => import('../pages/Students/AddStudentApplication'));
export const AssignSession = lazy(() => import('../pages/Students/AssignSession'));
export const StudentList = lazy(() => import('../pages/Students/StudentList'));
export const StudentTransfer = lazy(() => import('../pages/Students/StudentTransfer'));
export const TransferHistory = lazy(() => import('../pages/Students/TransferHistory'));
export const BulkSendDocument = lazy(() => import('../pages/Students/BulkSendDocument'));
export const PreviousCourse = lazy(() => import('../pages/Students/PreviousCourse'));
export const AllAppliedCandidates = lazy(() => import('../pages/Applications/AllAppliedCandidates'));
export const AddAttendance = lazy(() => import('../pages/Attendance/AddAttendance'));
export const AttendanceReport = lazy(() => import('../pages/Attendance/AttendanceReport'));
export const Billing = lazy(() => import('../pages/Finance/Billing'));
export const AddEmployee = lazy(() => import('../pages/Instructors/AddEmployee'));
export const AllInstructors = lazy(() => import('../pages/Instructors/AllInstructors'));
export const AddStaff = lazy(() => import('../pages/Staff/AddStaff'));
export const AllStaffs = lazy(() => import('../pages/Staff/AllStaffs'));
export const Positions = lazy(() => import('../pages/Staff/Positions'));
export const UserManagement = lazy(() => import('../pages/Staff/UserManagement'));
export const CareerCoaches = lazy(() => import('../pages/Staff/CareerCoaches'));
export const StaffWorkforces = lazy(() => import('../pages/Staff/Workforces'));
export const Sessions = lazy(() => import('../pages/Sessions/Sessions'));
export const Courses = lazy(() => import('../pages/Courses/Courses'));
export const SendAnnouncement = lazy(() => import('../pages/Notifications/SendAnnouncement'));
export const AnnouncementsList = lazy(() => import('../pages/Notifications/AnnouncementsList'));
export const SendSMS = lazy(() => import('../pages/Notifications/SendSMS'));
export const AllSMS = lazy(() => import('../pages/Notifications/AllSMS'));
export const SMSChat = lazy(() => import('../pages/Notifications/SMSChat'));
export const SendPassword = lazy(() => import('../pages/Notifications/SendPassword'));
export const AcademicYear = lazy(() => import('../pages/Profile/AcademicYear'));
export const Departments = lazy(() => import('../pages/Profile/Departments'));
export const Semesters = lazy(() => import('../pages/Profile/Semesters'));
export const Designations = lazy(() => import('../pages/Profile/Designations'));
export const Locations = lazy(() => import('../pages/Profile/Locations'));
export const DaysPreferred = lazy(() => import('../pages/Profile/DaysPreferred'));
export const Individuals = lazy(() => import('../pages/Profile/Individuals'));
export const Workforces = lazy(() => import('../pages/Profile/Workforces'));
export const MasterData = lazy(() => import('../pages/Profile/MasterData'));
export const Particulars = lazy(() => import('../pages/Profile/Particulars'));
export const UpdateCourseSession = lazy(() => import('../pages/UpdateCourseSession'));
export const Vouchers = lazy(() => import('../pages/Students/Vouchers'));
